<template>
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M10.91 8C10.9103 8.09978 10.8899 8.19853 10.85 8.29C10.8085 8.37731 10.7547 8.45815 10.69 8.53L6.46 12.61C6.39477 12.6995 6.31052 12.7734 6.21332 12.8265C6.11611 12.8796 6.00836 12.9105 5.8978 12.9169C5.78725 12.9234 5.67663 12.9053 5.57389 12.864C5.47115 12.8226 5.37884 12.759 5.3036 12.6778C5.22836 12.5965 5.17205 12.4996 5.13871 12.394C5.10537 12.2884 5.09584 12.1767 5.11079 12.067C5.12574 11.9572 5.16481 11.8522 5.22519 11.7593C5.28557 11.6665 5.36576 11.5882 5.46 11.53L8.3 8.75H2C1.80109 8.75 1.61032 8.67098 1.46967 8.53033C1.32902 8.38968 1.25 8.19891 1.25 8C1.25 7.80109 1.32902 7.61032 1.46967 7.46967C1.61032 7.32902 1.80109 7.25 2 7.25H8.3L5.42 4.47C5.27955 4.32937 5.20066 4.13875 5.20066 3.94C5.20066 3.74125 5.27955 3.55063 5.42 3.41C5.56188 3.27195 5.75204 3.1947 5.95 3.1947C6.14796 3.1947 6.33812 3.27195 6.48 3.41L10.7 7.48C10.7647 7.55185 10.8185 7.63269 10.86 7.72C10.8951 7.80908 10.9121 7.90427 10.91 8ZM14.75 14V2C14.75 1.80109 14.671 1.61032 14.5303 1.46967C14.3897 1.32902 14.1989 1.25 14 1.25C13.8011 1.25 13.6103 1.32902 13.4697 1.46967C13.329 1.61032 13.25 1.80109 13.25 2V14C13.25 14.1989 13.329 14.3897 13.4697 14.5303C13.6103 14.671 13.8011 14.75 14 14.75C14.1989 14.75 14.3897 14.671 14.5303 14.5303C14.671 14.3897 14.75 14.1989 14.75 14Z"
            fill="#8897AA"
        />
    </svg>
</template>

<script setup>

</script>

<style scoped>
    svg:hover path{
        fill: #2A8176;
    }
</style>